// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-box {
    border: 2px solid #3e3f40;
    border-radius: 5px;
    width: 100%;
    height: 100px;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.search-box textarea {
    border: none;
    outline: none;
    background: transparent;
    color: #fff;
    width: 100%;
    height: 100%;
    resize: none;
    margin: 10px;
}

.search-box textarea::placeholder {
    color: #8d9191;
}

.search-box-button-container {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-start;
    padding: 5px;
}

.search-box button {
    background: transparent;
    color: #fff;
    cursor: pointer;
    border-radius: 100%;
    background-color: #4a4a4a;
    border: none;
    padding: 10px;
    width: fit-content;
}

.search-box button:hover {
    background-color: #5a5a5a;
}

`, "",{"version":3,"sources":["webpack://./src/components/SearchBox.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,aAAa;;IAEb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".search-box {\n    border: 2px solid #3e3f40;\n    border-radius: 5px;\n    width: 100%;\n    height: 100px;\n\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.search-box textarea {\n    border: none;\n    outline: none;\n    background: transparent;\n    color: #fff;\n    width: 100%;\n    height: 100%;\n    resize: none;\n    margin: 10px;\n}\n\n.search-box textarea::placeholder {\n    color: #8d9191;\n}\n\n.search-box-button-container {\n    display: flex;\n    flex-direction: column-reverse;\n    justify-content: flex-start;\n    padding: 5px;\n}\n\n.search-box button {\n    background: transparent;\n    color: #fff;\n    cursor: pointer;\n    border-radius: 100%;\n    background-color: #4a4a4a;\n    border: none;\n    padding: 10px;\n    width: fit-content;\n}\n\n.search-box button:hover {\n    background-color: #5a5a5a;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
